import axios from "axios";
import { envConfig } from '@/js/constants';
var instance = axios.create({
  baseURL: envConfig['svc_apis_host'],
  headers: {
    "Content-Type": "application/json"
  }
});
export default instance;